export default __webpack_public_path__ + "static/media/mirage-list-is-empty.7e9395ac.png";